'use strict'

export class DynamicPageInfoDataUrls {
    static Get_DynamicPageData: string = "api/FAPageData/Get_DynamicPageData";
}
